<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.full_name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.full_name }}</p>
      <small>IP Learn</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-4">
        <img v-if="activeUserInfo.profile_picture" key="onlineImg" :src="activeUserInfo.profile_picture" alt="user-img" width="40" height="40" class="rounded shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="themeToggleSettings = !themeToggleSettings">
            <feather-icon icon="SunIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Theme</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Logout</span>
          </li>

        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup :active.sync="themeToggleSettings" title="Change Theme">
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 hover:text-primary text-black cursor-pointer">
          <div class="border border-solid m-3 p-6 rounded bg-white" style="background-color: #F2F2F2" @click="toggleTheme('light')" :class="currentTheme === 'light' ? 'border-success' : 'border-none'">
            <div class="flex items-center justify-center">
              <feather-icon icon="SunIcon" svgClasses="h-16 w-16"/>
            </div>
            <h2 class="text-center text-black mt-4">Bright</h2>
          </div>
        </div>
        <div class="vx-col w-1/3 hover:text-primary text-white cursor-pointer">
          <div class="border border-solid m-3 p-6 rounded" style="background-color: #050056" @click="toggleTheme('midnight')" :class="currentTheme === 'midnight' ? 'border-success' : 'border-none'">
            <div class="flex items-center justify-center">
              <feather-icon icon="CloudIcon" svgClasses="h-16 w-16"/>
            </div>
            <h2 class="text-center mt-4 text-white">Midnight</h2>
          </div>
        </div>
        <div class="vx-col w-1/3 hover:text-primary text-white cursor-pointer">
          <div class="border border-solid m-3 p-6 rounded" style="background-color: #1B1E22" @click="toggleTheme('dark')" :class="currentTheme === 'dark' ? 'border-success' : 'border-none'">
            <div class="flex items-center justify-center">
              <feather-icon icon="MoonIcon" svgClasses="h-16 w-16"/>
            </div>
            <h2 class="text-center mt-4 text-white">Dark</h2>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>

export default {
  data () {
    return {
      themeToggleSettings: false
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentTheme () {
      return this.$store.state.theme
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')

      location.href = '/'

    },
    toggleTheme (color) {
      if (color === 'dark' || color === 'light' || color === 'midnight') {
        localStorage.setItem('selectedTheme', color)
        location.reload()
      }
    }
  }
}
</script>
